<template>
  <div class="ac-shell">
    <header class="ac-header">
      <div class="ac-wrap ac-header__inner">
        <a href="#" class="ac-brand" @click.prevent="goHome">
          <span class="ac-brand__mark">高</span>
          <div>
            <strong>高仁学堂</strong>
            <p>企业培训在线学习平台</p>
          </div>
        </a>
        <nav class="ac-nav">
          <router-link
            v-for="item in navItems"
            :key="item.to"
            :to="item.to"
            class="ac-nav__link"
            :class="{ 'ac-nav__link--active': isActive(item) }"
          >
            {{ item.label }}
          </router-link>
        </nav>
        <button type="button" class="ac-header__btn" @click="$emit('enroll')">立即报名</button>
      </div>
    </header>
    <slot />
  </div>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router'

defineEmits(['enroll'])

const route = useRoute()
const router = useRouter()

const navItems = [
  { label: '最新课程', to: { name: 'training' }, match: ['training'] },
  { label: '在线考试', to: { name: 'training-exam' }, match: ['training-exam'] },
  { label: '知识资料', to: { name: 'training-knowledge' }, match: ['training-knowledge'] },
]

function isActive(item) {
  if (item.match.includes(route.name)) return true
  if (route.name === 'training-course' && item.label === '最新课程') return true
  return false
}

function goHome() {
  router.push({ name: 'training' })
}
</script>

<style scoped>
.ac-shell {
  --ac-blue: #2d8cf0;
  --ac-orange: #ff6a00;
  --ac-orange-dark: #e85f00;
  --ac-bg: #f5f7fa;
  --ac-text: #333;
  --ac-sub: #666;
  --ac-muted: #999;
  --ac-line: #e8e8e8;
  min-height: 70vh;
  background: var(--ac-bg);
  color: var(--ac-text);
  font-family: "PingFang SC", "Microsoft YaHei", "Helvetica Neue", Arial, sans-serif;
  padding-bottom: 48px;
}

.ac-wrap {
  width: min(1160px, calc(100% - 40px));
  margin: 0 auto;
}

.ac-header {
  background: #fff;
  border-bottom: 1px solid var(--ac-line);
  position: sticky;
  top: 0;
  z-index: 30;
}

.ac-header__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 56px;
  padding: 8px 0;
}

.ac-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: inherit;
  flex-shrink: 0;
}

.ac-brand__mark {
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  border-radius: 8px;
  background: var(--ac-blue);
  color: #fff;
  font-weight: 700;
  font-size: 16px;
}

.ac-brand strong {
  display: block;
  font-size: 16px;
  line-height: 1.2;
  color: #222;
}

.ac-brand p {
  margin: 2px 0 0;
  font-size: 12px;
  color: var(--ac-muted);
}

.ac-nav {
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1;
  justify-content: center;
}

.ac-nav__link {
  padding: 8px 14px;
  color: var(--ac-sub);
  text-decoration: none;
  font-size: 14px;
  border-radius: 4px;
}

.ac-nav__link:hover,
.ac-nav__link--active {
  color: var(--ac-blue);
}

.ac-header__btn {
  margin-left: auto;
  padding: 8px 18px;
  border: none;
  border-radius: 4px;
  background: var(--ac-orange);
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  flex-shrink: 0;
}

.ac-header__btn:hover {
  background: var(--ac-orange-dark);
}

@media (max-width: 760px) {
  .ac-brand p,
  .ac-nav {
    display: none;
  }

  .ac-wrap {
    width: calc(100% - 24px);
  }
}
</style>
